import styled from "@emotion/styled";
import { FC } from "react";
import { clientEnvModule } from "@/modules/client-env";
import { isMac } from "@/domains/platform/isMac";
import { DesktopMenuButton } from "@/components/desktop/desktop-menu-button";
import { ZIndex } from "@/domains/design/constants";
import { appRoutes } from "@/app/router/appRoutes";

export const DesktopMenuOverlay: FC = () => {
  // The floating-agent widget window boots this same app; the main-window menu
  // button must not paint over the circle. Desktop uses a hash router, and this
  // overlay mounts outside the router context, so read the hash directly.
  // eslint-disable-next-line no-restricted-properties
  const isFloatingAgentWindow = window.location.hash.startsWith(
    `#${appRoutes.floatingAgent({}).path}`
  );
  const shouldShow = clientEnvModule.isDesktop() && !isMac() && !isFloatingAgentWindow;
  if (!shouldShow) return null;

  return (
    <OverlayWrapper>
      <DesktopMenuButton />
    </OverlayWrapper>
  );
};

const OverlayWrapper = styled.div({
  position: "absolute",
  top: 8,
  left: 24,
  zIndex: ZIndex.DesktopMenuOverlay,
  WebkitAppRegion: "no-drag",
  pointerEvents: "auto",
});
